import styled from 'styled-components';
import { HStack, VStack } from 'components/layouts/primitives/Stack/Stack';
import { Box } from 'components/layouts/primitives/Box/Box';
import { padding } from 'styles/styles';

export const InvitationExpiredPageStyle = {
  Container: styled(VStack)`
    min-height: 100vh;
    width: 100%;
    max-width: 640px;
    margin: 0 auto;
  `,
  Content: styled(HStack)`
    padding: ${padding.paddingNone} 40px;
  `,
  Footer: styled(Box)`
    padding: 40px ${padding.paddingNone};
  `,
};
